import googleLogo from '../../../assets/google-logo.svg';
import { FormattedMessage } from 'react-intl';
import { Stack, Typography } from '@mui/material';
import { loginPage } from '../../../constants/intlMessageIds';
import { pageRoutes } from '../../../constants/routes';
import { pxToRem } from '../../../utils/getFontValue';
import { UIColors } from '../../../constants/UIConstants';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  GoogleSignInButton,
  GoogleLoader,
  LoginCard,
  StyledGoogleBox,
} from '../../../components/styled/loginComponents';
import {
  googleSignIn,
  isCognitoSessionActive,
} from '../../../utils/auth/amplify';

/*
 * Password login disabled — legacy forms live in FirstTimeLogin.tsx / ForgotPassword.tsx.
 */

function LoginAndGoogleSSO() {
  const navigate = useNavigate();
  const [displayGoogleLoader, setDisplayGoogleLoader] = useState(false);

  const handleGoogleSignIn = async () => {
    setDisplayGoogleLoader(true);
    await googleSignIn();
  };

  const checkSession = useCallback(async () => {
    if (await isCognitoSessionActive()) {
      navigate(pageRoutes.onboarding);
    }
  }, [navigate]);

  useEffect(() => {
    checkSession();
  }, [checkSession]);

  return (
    <LoginCard>
      <Stack spacing={3} alignItems="stretch">
        <Stack spacing={1} textAlign="center">
          <Typography
            component="h1"
            variant="h5"
            fontWeight={700}
            color={UIColors.primary.navyBlue}
            sx={{ fontSize: pxToRem(28), lineHeight: 1.2 }}
          >
            <FormattedMessage
              id={loginPage.welcomeTitle.id}
              defaultMessage={loginPage.welcomeTitle.default}
            />
          </Typography>
          <Typography
            variant="body2"
            color={UIColors.textColors.grey80}
            sx={{ fontSize: pxToRem(15), lineHeight: 1.5 }}
          >
            <FormattedMessage
              id={loginPage.welcomeSubtitle.id}
              defaultMessage={loginPage.welcomeSubtitle.default}
            />
          </Typography>
        </Stack>

        <GoogleSignInButton
          type="button"
          variant="outlined"
          onClick={handleGoogleSignIn}
          disabled={displayGoogleLoader}
          startIcon={
            <StyledGoogleBox>
              {!displayGoogleLoader ? (
                <img
                  src={googleLogo}
                  height="100%"
                  width="100%"
                  alt=""
                  aria-hidden
                />
              ) : (
                <GoogleLoader size={pxToRem(22)} thickness={2.75} />
              )}
            </StyledGoogleBox>
          }
        >
          <FormattedMessage
            id={loginPage.googleSignInButton.id}
            defaultMessage={loginPage.googleSignInButton.default}
          />
        </GoogleSignInButton>

        <Typography
          variant="caption"
          color={UIColors.textColors.grey80}
          textAlign="center"
          sx={{ fontSize: pxToRem(13), lineHeight: 1.5, px: 1 }}
        >
          <FormattedMessage
            id={loginPage.signInHelp.id}
            defaultMessage={loginPage.signInHelp.default}
          />
        </Typography>
      </Stack>
    </LoginCard>
  );
}

export default LoginAndGoogleSSO;
